import React from 'react';
import UnscorableDifferentialItem from 'js/components/Charts/Differential/UnscorableDifferentialItem';

export const UnscorableQuestionDifferential = (props) => {
  return <UnscorableDifferentialItem {...props} />;
};

export default UnscorableQuestionDifferential;
